<app-table-chart />

<div class="card mt-10 flex items-center gap-6 p-5">
  <button mat-button (click)="back.emit()">
    {{ 'common.back' | translate }}
  </button>
  <button mat-flat-button (click)="onContinue()" [disabled]="loading()">
    {{ (loading() ? 'common.creating...' : 'common.continue') | translate }}
  </button>
</div>
